import { render, staticRenderFns } from "./VerifyEmailContactUs.vue?vue&type=template&id=5766828b&scoped=true&"
import script from "./VerifyEmailContactUs.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailContactUs.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmailContactUs.vue?vue&type=style&index=0&id=5766828b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5766828b",
  null
  
)

export default component.exports